import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../../services/filtering/filter-form-render-service';
import messages from './messages';

export const CREATE_DATES = 'createDates';

export default {
  id: CREATE_DATES,
  displayName: () => <FormattedMessage {...messages.createDate} />,
  type: OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS,
  filterValue: 'createDates',
  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_DATE_COMPARISON_SHIPMENTS, criteriaInformations);
  },
};
